import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Stack } from '@atlaskit/primitives/compiled';
import Spinner, { type SpinnerProps } from '@atlaskit/spinner';

const styles = cssMap({
	loadingSpinnerStyles: {
		height: '100%',
	},
});

export const LoadingSpinner = (props: SpinnerProps) => {
	return (
		<Stack grow="fill" alignBlock="center" alignInline="center" xcss={styles.loadingSpinnerStyles}>
			<Spinner {...props} />
		</Stack>
	);
};
